/** @format */

import { useEffect } from 'react'
import { asyncGetProductList } from 'src/store/globalDataSlice'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, AppDispatch } from 'src/store'
import dayjs from 'dayjs'

// type useGlobalData<TYPE, T> = (dataType: TYPE) => T

const useGlobalData = dataType => {
  const globalData = useSelector((state: RootState) => state.globalData)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    const data = globalData[dataType]
    const { list, startTime } = data
    const expired = startTime ? dayjs().diff(dayjs(startTime), 'days') > 0 : true
    if (!list?.length || expired) {
      dispatch(asyncGetProductList(dataType))
    }
  }, [])

  return globalData[dataType].list
}

export default useGlobalData
